import { Center } from '@mantine/core'
import React from 'react'

import { spaceGradeVideoMaxQualityMap } from '../../../constants'
import { useApplicationContext } from '../../../contexts'
import { VideoPlayer } from '../../VideoPlayer'
import type { FileItemProps } from '../types'

export const VideoFile = ({ file, ...rest }: FileItemProps) => {
    const { spaceVersion } = useApplicationContext()
    const maxQuality = spaceVersion ? spaceGradeVideoMaxQualityMap[spaceVersion] : undefined
    return (
        <Center sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
            <VideoPlayer source={file.url} isController maxQuality={maxQuality} {...rest} />
        </Center>
    )
}
